import React from 'react';

const IconPnL = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 5C2.25 4.58579 2.58579 4.25 3 4.25H21C21.4142 4.25 21.75 4.58579 21.75 5V19C21.75 19.4142 21.4142 19.75 21 19.75H13.2271L10.416 21.624C10.237 21.7434 10.0154 21.7801 9.8075 21.7249C9.59958 21.6697 9.42539 21.5278 9.32918 21.3354L8.53647 19.75H3C2.58579 19.75 2.25 19.4142 2.25 19V5ZM3.75 5.75V18.25H9C9.28408 18.25 9.54378 18.4105 9.67082 18.6646L10.2909 19.9047L12.584 18.376C12.7072 18.2938 12.8519 18.25 13 18.25H20.25V5.75H3.75Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6 7.55C18.8486 7.88137 18.7814 8.35147 18.45 8.6L14.45 11.6C14.2228 11.7704 13.9187 11.7979 13.6646 11.6708L10.0792 9.87811L6.45004 12.6C6.11867 12.8485 5.64857 12.7814 5.40004 12.45C5.15152 12.1186 5.21867 11.6485 5.55004 11.4L9.55004 8.4C9.77731 8.22955 10.0814 8.20213 10.3355 8.32918L13.9209 10.1219L17.55 7.4C17.8814 7.15147 18.3515 7.21863 18.6 7.55Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7.25C6.41421 7.25 6.75 7.58579 6.75 8V15.25H18C18.4142 15.25 18.75 15.5858 18.75 16C18.75 16.4142 18.4142 16.75 18 16.75H6C5.58579 16.75 5.25 16.4142 5.25 16V8C5.25 7.58579 5.58579 7.25 6 7.25Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 9.25C10.4142 9.25 10.75 9.58579 10.75 10L10.75 16C10.75 16.4142 10.4142 16.75 10 16.75C9.58579 16.75 9.25 16.4142 9.25 16L9.25 10C9.25 9.58579 9.58579 9.25 10 9.25Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 11.25C18.4142 11.25 18.75 11.5858 18.75 12L18.75 16C18.75 16.4142 18.4142 16.75 18 16.75C17.5858 16.75 17.25 16.4142 17.25 16L17.25 12C17.25 11.5858 17.5858 11.25 18 11.25Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 10.25C14.4142 10.25 14.75 10.5858 14.75 11L14.75 16C14.75 16.4142 14.4142 16.75 14 16.75C13.5858 16.75 13.25 16.4142 13.25 16L13.25 11C13.25 10.5858 13.5858 10.25 14 10.25Z"
        fill="#333333"
      />
    </svg>
  );
};

export default IconPnL;
